import { SVGIconProps } from './types'

export const ThumbsUpIcon = (props: SVGIconProps) => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.375 6.875L6.875 1.25C7.37228 1.25 7.84919 1.44754 8.20083 1.79917C8.55246 2.15081 8.75 2.62772 8.75 3.125V5.625H12.2875C12.4687 5.62295 12.6482 5.66031 12.8135 5.73451C12.9788 5.80871 13.126 5.91796 13.2449 6.0547C13.3638 6.19143 13.4516 6.35239 13.5021 6.52641C13.5526 6.70043 13.5647 6.88335 13.5375 7.0625L12.675 12.6875C12.6298 12.9856 12.4784 13.2573 12.2487 13.4525C12.019 13.6478 11.7265 13.7534 11.425 13.75H4.375M4.375 6.875V13.75M4.375 6.875H2.5C2.16848 6.875 1.85054 7.0067 1.61612 7.24112C1.3817 7.47554 1.25 7.79348 1.25 8.125V12.5C1.25 12.8315 1.3817 13.1495 1.61612 13.3839C1.85054 13.6183 2.16848 13.75 2.5 13.75H4.375"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
